import { createApp } from "vue";
import GlobalDialog from "@/pages/globalMask/index.vue";

export default {
  install(app) {
    let instance;

    // #ifdef H5
    const DialogApp = createApp(GlobalDialog);
    instance = DialogApp.mount(document.createElement("div"));
    document.body.appendChild(instance.$el);
    // #endif

    // 添加全局方法
    app.config.globalProperties.$openGlobalDialog = (e) => {
      let { content, type ,btnText,customerServiceText} = e;
      // #ifdef H5
      instance.openDialog(e);
      // #endif

      // #ifdef APP
      uni.navigateTo({
        url: `/pages/globalMask/index?content=${content}&type=${type}&btnText=${btnText}&customerServiceText=${customerServiceText}`,
      });
      // #endif
    };
    app.config.globalProperties.$closeGlobalDialog = () => {
      // #ifdef H5
      instance.closeDialog();
      // #endif

      // #ifdef APP
      if (getCurrentPages().length > 1) {
        uni.navigateBack();
      } else {
        uni.switchTab({
          url: "/pages/tabbar/home/index",
        });
      }
      // #endif
    };
  },
};
